import { createAsyncThunk } from "@reduxjs/toolkit";
import { IAuthNativeSuccessResponse } from "models/Login/choiceMerchant.model";

import { MerchantSwitch } from "services/merchantSwitch.service";

//4 api -> 5 api
export const merchantSwitchSuccessAsync = createAsyncThunk(
  "merchantSwitch",
  async (): Promise<IAuthNativeSuccessResponse> => {
    try {
      const response = await MerchantSwitch();
      return response;
    } catch (error: any) {
      throw error;
    }
  }
);
